

import React, { useState } from 'react';

const AdminSupport = () => {
  const [processOpen, setProcessOpen] = useState(1);

  // Service process steps
  const processSteps = [
    {
      title: '01. Onboarding',
      body: 'Map recurring tasks and security protocols.'
    },
    {
      title: '02. Playbook',
      body: 'Creation SOPs, SLAs, and escalation paths documented.'
    },
    {
      title: '03. Execution',
      body: 'Daily task completion with real-time dashboards.'
    },
    {
      title: '04. Quality Review',
      body: 'Weekly audits, efficiency metrics, and feedback loops.'
    },
    {
      title: '05. Scale Up',
      body: 'Add new tasks or hours as your business grows.'
    }
  ];

  return (
    <div className="page_wrapper">
      <main className="page_content">
        {/* Banner Section */}
        <section className="page_banner_section text-center" style={{ backgroundImage: "url('assets/images/shapes/bg_pattern_3.svg')",marginTop: '90px' }}>
          <div className="container">
            <div className="heading_focus_text text-white">
              Service <span className="badge bg-secondary">Details </span>
            </div>
            <h1 className="page_title mb-0 text-white">Reliable Admin Support</h1>
          </div>
        </section>

        {/* Service Details Section */}
        <section className="service_details_section section_space bg-light">
          <div className="container">
            <div className="details_item_image position-relative">
              <img src="assets/images/service-details/Admin Support Service.jpg" alt="Service Details Image" />
            </div>
            <h2 className="details_item_title">Reliable Admin Support</h2>
            <p>
              Free your leadership from repetitive tasks.
            </p>
            <p>
              Our vetted virtual assistants handle scheduling, travel, invoicing, document prep, and CRM updates with impeccable accuracy and confidentiality.
            </p>

            <h3 className="details_item_info_title">Service Process</h3>
            <div className="row mb-5 align-items-center justify-content-lg-between">
              <div className="col-lg-6">
                <div className="accordion" id="service_process_faq">
                  {processSteps.map((step, idx) => (
                    <div className="accordion-item" key={idx}>
                      <div
                        className={`accordion-button${processOpen === idx + 1 ? '' : ' collapsed'}`}
                        role="button"
                        onClick={() => setProcessOpen(processOpen === idx + 1 ? null : idx + 1)}
                        aria-expanded={processOpen === idx + 1}
                        aria-controls={`collapse_${idx}`}
                      >
                        {step.title}
                      </div>
                      <div
                        id={`collapse_${idx}`}
                        className={`accordion-collapse collapse${processOpen === idx + 1 ? ' show' : ''}`}
                        data-bs-parent="#service_process_faq"
                      >
                        <div className="accordion-body">
                          <p className="m-0">{step.body}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-5">
                <ul className="content_layer_group unordered_list_block text-center">
                  {processSteps.map((step, idx) => (
                    <li
                      className={`accordion-button${processOpen === idx + 1 ? '' : ' collapsed'}`}
                      role="button"
                      key={idx}
                      onClick={() => setProcessOpen(processOpen === idx + 1 ? null : idx + 1)}
                      aria-expanded={processOpen === idx + 1}
                      aria-controls={`collapse_${idx}`}
                    >
                      <span>{step.title.split('. ')[1]}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <h3 className="details_item_info_title">Services Outcome</h3>
            <p className="mb-4">
              A cost-effective operations engine that lets your core team focus on high-value work.
            </p>
            <div className="row mb-4">
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Up to 40 % time savings for execs
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      99 % task accuracy rate
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Secure data-handling compliance
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Flexible hours & quick ramp-up
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Real-time productivity reports
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Seamless tool integration (G-Suite, MS 365, CRM)
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/virtual assistant.jpg" alt="Service Details Image" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/administrative tasks.jpg" alt="Service Details Image" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/back-office support.jpg" alt="Service Details Image" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call To Action Section */}
        <section className="calltoaction_section parallaxie" style={{ backgroundImage: "url('assets/images/backgrounds/staffing.jpg')" }}>
          <div className="container text-center">
            <div className="heading_block text-white">
              <h2 className="heading_text">
                Ready to Work, Let's Chat
              </h2>
              <p className="heading_description mb-0">
                Our team of experts is ready to collaborate with you every step of the way, from initial consultation to implementation.
              </p>
            </div>
            <a className="btn btn-primary" href="/contact">
              <span className="btn_label" data-text="Contact Us Today!">Contact Us Today!</span>
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AdminSupport;
